import request from "../../../utils/request";


export const getUsers = '/user/'


export function modifyUser(values: any) {
    if (typeof values.roleIds === "number") {
        values.roleIds = [values.roleIds]
    }
    return request.request({
        url: '/user/',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function deleteUser(userId: any) {
    return request.request({
        url: '/user/',
        method: "delete",
        params: {userId}
    })
}

export function updateUserStatus(userId: any, status: any) {
    return request.put('/user/status', {userId, status});
}

export function resetUserPassword(userId: any) {
    return request.post('/user/password/reset', {userId})
}

export function setUserCompanies(data: any) {
    return request.request({
        url: '/user/company',
        method: "post",
        data: data
    })
}
